import React from 'react';
import DaysWeek from "./DaysWeek";
import DataWeek from "./DataWeek";


function GridWeek(props) {
    return (
        <>
            <div className="grid_week">
                <DaysWeek _data={props._data}/>
                <DataWeek _data={props._data} _clk={props._clk}/>
            </div>
        </>
    );
}

export default GridWeek;
